import * as React from "react";
import BaseLayout from "../../components/BaseLayout";
import InstallationMainCard from "../../features/Installation/InstallationMainCard";

function InstallationPage() {
  return (
    <BaseLayout>
      <InstallationMainCard />
    </BaseLayout>
  );
}

export default InstallationPage;
